export default __webpack_public_path__ + "static/media/googs.d19c72b8.png";